import {
  LeftOutlined,
  RightOutlined,
  ShoppingOutlined,
} from '@ant-design/icons';
import {Spin} from 'antd';
import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {RqGetNewArrivalsProducts} from '../../../reactQuery/apis';

const NewArrivals = () => {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState('next');

  const {
    data: apiData,
    isLoading,
    isError,
  } = RqGetNewArrivalsProducts();

  /* Normalize API response */
  const products = useMemo(() => {
    if (!apiData) {return [];}
    return Object.values(apiData).flat();
  }, [apiData]);

  /* Auto slide */
  useEffect(() => {
    if (products.length === 0) {return;}

    const interval = setInterval(() => {
      setDirection('next');
      setCurrentIndex(prev => (prev + 1) % products.length);
    }, 2500);

    return () => clearInterval(interval);
  }, [products.length]);

  const nextSlide = () => {
    setDirection('next');
    setCurrentIndex(prev => (prev + 1) % products.length);
  };

  const prevSlide = () => {
    setDirection('prev');
    setCurrentIndex(prev => (prev - 1 + products.length) % products.length);
  };

  const toDropboxRawUrl = (url = '') =>
    url.replace('www.dropbox.com', 'dl.dropboxusercontent.com')
      .replace('?dl=0', '');

  const animationClass =
    direction === 'next'
      ? 'animate-slide-next'
      : 'animate-slide-prev';

  const getVisibleSlides = () => {
    const slides = [];
    for (let i = -2; i <= 2; i++) {
      const index = (currentIndex + i + products.length) % products.length;
      slides.push({...products[index], position: i});
    }
    return slides;
  };

  if (isLoading) {
    return (
      <div className={'py-20 flex justify-center'}>
        <Spin size={'large'} />
      </div>
    );
  }

  if (isError || products.length === 0) {return null;}

  return (
    <div data-aos={'fade-up'} className={'px-2 w-full flex justify-center items-center text-center'}>
      <div className={'section'}>
        <h1 data-aos={'fade-up'} className={'title'}>New Arrivals</h1>

        <div data-aos={'fade-up'} className={'relative min-h-[450px] lg:min-h-[520px] overflow-hidden'}>
          <div className={'relative h-full flex justify-center items-center'}>
            {getVisibleSlides().map((product, idx) => {
              const {position} = product;

              let translateX = position * 280;
              let scale = 1;
              let zIndex = 5;

              if (position === -2 || position === 2) {
                scale = 0.74;
                zIndex = 1;
              } else if (position === -1 || position === 1) {
                scale = 0.82;
                zIndex = 3;
              }

              return (
                <div
                  key={`${product.id}-${idx}`}
                  className={`absolute transition-all duration-500 ease-out ${animationClass}`}
                  style={{
                    '--base-transform': `translateX(${translateX}px) scale(${scale})`,
                    transform: 'var(--base-transform)',
                    zIndex,
                    // opacity,
                    left: '50%',
                    top: '0',
                    marginLeft: '-140px',
                  }}
                >
                  <button
                    className={
                      'relative bg-white rounded-lg shadow-lg overflow-hidden group border border-white p-2 cursor-pointer'
                    }
                    onClick={() =>
                      navigate(`/product/${product.id}`)
                    }
                  >
                    <img
                      src={toDropboxRawUrl(product.imageUrl?.[0] ||
                        product.variants?.[0]?.images?.[0])}
                      alt={product.productName}
                      className={
                        'w-[280px] h-[420px] object-cover rounded-lg'
                      }
                    />

                    <div
                      className={
                        'absolute bottom-4 left-1/2 -translate-x-1/2 bg-white px-4 py-2 rounded-full shadow font-semibold text-sm'
                      }
                    >
                      {product.productName}
                    </div>

                    <button
                      className={
                        'absolute top-4 right-4 bg-white p-3 rounded-full shadow opacity-0 group-hover:opacity-100 transition'
                      }
                    >
                      <ShoppingOutlined />
                    </button>
                  </button>
                </div>
              );
            })}
          </div>

          {/* Navigation */}
          <button
            onClick={prevSlide}
            className={
              'absolute left-4 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow z-10'
            }
          >
            <LeftOutlined />
          </button>

          <button
            onClick={nextSlide}
            className={
              'absolute right-4 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow z-10'
            }
          >
            <RightOutlined />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewArrivals;
